<template>
    <div class="homeworkRecords commonBackground margin-top padding-x-y">
        <common-agt-hk-window ref="commonAgHkWindow" @immediatelyArrange="immediatelyArrange"></common-agt-hk-window>

        <div class="title text-l-size">作业记录</div>
        <el-divider></el-divider>
        <div class="position-relative condition" >
            <loading :show="conditionLoading" height="200px" style="z-index:9999;height: 100%;"></loading>
            <div>
                <div class="secondLine">
                    <span class="text-small-secondary">学科：</span>
                    <el-button size="small" @click="selectSubject(item.subjectId)"
                               :class="subjectId===item.subjectId?'active':''"
                               class="text-default-color"
                               type="text" v-for="item in subjectList" :key="item.subjectId">
                        {{item.subjectName}}
                    </el-button>
                </div>
                <div class="margin-medium-top">
                    <span>布置时间：</span>
                    <el-radio-group v-model="timeId"  size="small"  @change="selectTime()">
                        <el-radio-button
                                v-for="item in timeList"
                                :key="item.timeScope"
                                class="text-ellipsis"
                                :title="item.text"
                                :label="item.timeScope">
                            {{item.text}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="margin-medium-top delFloat thirdLine">
                    <div class="float-left">
                        <span>布置年级：</span>
                        <el-select v-model="gradeId"
                                   @change="selectGrade"
                                   placeholder="请选择"
                                   size="small">
                            <el-option
                                    v-for="item in gradeList"
                                    :key="item.graduateYear"
                                    :label="item.gradeName"
                                    :value="item.graduateYear">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="float-left">
                        <span>作业类型：</span>
                        <el-select v-model="homeTypeId"
                                   size="small" @change="selectHomeworkType" placeholder="请选择">
                            <el-option
                                    v-for="item in homeTypeList"
                                    :key="item.typeId"
                                    :label="item.typeName"
                                    :value="item.typeId">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="float-left">
                        <span>布置人：</span>
                        <el-select v-model="personId"
                                   @change="selectPerson"
                                   size="small"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in personDownList"
                                    :key="item.teacherId"
                                    :label="item.teacherName"
                                    :value="item.teacherId">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="float-left">
                        <span>状态：</span>
                        <el-select v-model="teacherStatusId"
                                   @change="selectStatus"
                                   size="small"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in teacherStatusList"
                                    :key="item.status"
                                    :label="item.text"
                                    :value="item.status">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="sortPaper margin-medium-top delFloat">
                    <div class="float-left margin-right">
                        排序
                    </div>
                    <el-radio-group v-model="orderById"  @change="selectOrderPaper()">
                        <el-radio :label="item.orderBy" size="medium"
                                  style="padding: 0;line-height:34px;"
                                  :key="index"
                                  v-for="(item,index) in homeOrder">
                            {{item.text}}
                        </el-radio>
                    </el-radio-group>
                </div>
                <!--作业列表-->
                <div class="homeworkContentList position-relative">
                    <loading :show="contentLoading"  ></loading>
                    <empty v-show="homeContentList.length<1&&!contentLoading" content="暂无作业" :text-size="18" class="margin-medium-top"></empty>
                    <div   v-show="homeContentList.length>0">
                        <div class="margin-medium-top delFloat position-relative border-bottom padding-b" :key="item.id" v-for="item in homeContentList">
                            <div class="float-left left">
                                <el-tag  size="mini" color="orange"   class="nTag margin-right" effect="dark" v-show="item.typeName==='视频'">{{item.typeName}}</el-tag>
                                <el-tag  size="mini" class="margin-right nTag" effect="dark" v-show="item.typeName==='试卷'">{{item.typeName}}</el-tag>
                                <el-tag  size="mini" color="#8BC05D" class="nTag margin-right" effect="dark" v-show="item.typeName==='模拟选科'">{{item.typeName}}</el-tag>
                                <el-tag  size="mini" color="#FF705F" class="nTag margin-right" effect="dark" v-show="item.typeName==='计划'">{{item.typeName}}</el-tag>
                                <el-tag  size="mini" color="#39CFC3" class="nTag margin-right" effect="dark" v-show="item.typeName==='心理测评'">{{item.typeName}}</el-tag>
                                <el-tag  size="mini" color="#985CF6" class="nTag margin-right" effect="dark" v-show="item.typeName==='多学科'">{{item.typeName}}</el-tag>
                                <span class="margin-right text-m-size">{{item.title}}</span>
                                <el-tag size="mini">
                                    {{item.subjectName}}
                                </el-tag>
                                <div class="delFloat text-small-secondary margin-top">
                                    <span>开始时间：{{item.startAt}}</span>
                                    <span>已参与人数：{{item.startNum+'/'+item.totalNum}}</span>
                                    <span>
                                     布置人：{{item.teacherName}}
                                </span>
                                </div>
                                <div class="text-small-secondary margin-top">
                                    <span>截止时间：{{item.deadlineAt}}</span>
                                    <span>已完成人数：{{item.completeNum+'/'+item.totalNum}}</span>
                                </div>
                                <div class="margin-top dx position-relative" :class="bzDxShow===item.id?'show':''" >
                                    布置对象：
                                    <el-tag type="info" effect="dark" size="mini" v-for="(itemSon,index) in item.objects" :key="index" class="text-white margin-right">
                                        {{itemSon}}
                                    </el-tag>
                                    <div class="position-absolute right" v-show="item.objects.length>9">
                                        <el-button type="text" @click="bzDxShow=item.id" v-show="!bzDxShow" >更多 <span class="el-icon-arrow-up"></span></el-button>
                                        <el-button type="text" @click="bzDxShow=''" v-show="bzDxShow===item.id">收起 <span class="el-icon-arrow-down"></span></el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="right position-absolute">
                                <div class="text-right status">
                                    <span v-show="item.status===1" class="green">进行中</span>
                                    <span v-show="item.status===2" class="gray">已撤回</span>
                                    <span v-show="item.status===3" class="blue">未开始</span>
                                    <span v-show="item.status===4" class="danger">已截止</span>

                                </div>
                                <div class="margin-medium-top settingRight">
                                    <el-popover
                                            placement="top"
                                            width="200"
                                            trigger="hover">
                                        <div>
                                            <el-button type="text" :disabled="!item.canRecall" size="small" @click="recallHomework(item.id)">撤回作业</el-button>
                                        </div>
                                        <div>
                                            <el-button type="text" :disabled="!item.canEdit" size="small" @click="updateHomework(item.id)">修改作业</el-button>
                                        </div>
                                        <div>
                                            <el-button type="text" size="small" :disabled="!item.canReassign" @click="oneMoreTry(item.id)">再次布置</el-button>
                                        </div>
                                        <div>
                                            <el-button type="text" size="small" :disabled="!item.canDel" @click="delHomework(item.id)">删除作业</el-button>
                                        </div>
                                        <el-button slot="reference" size="small" plain class="margin-right">更多操作</el-button>
                                    </el-popover>
                                    <el-button  size="small" @click="lookDetail(item.title,item.id)" plain class="">查看详情</el-button>
                                </div>
                            </div>
                        </div>
                        <el-pagination
                                background
                                class="margin-top text-center"
                                @current-change="handleCurrentChange"
                                :current-page.sync="currentPage"
                                :page-size="20"
                                layout="prev, pager, next, jumper"
                                :total="totalItem">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import commonAgtHkWindow from '../../homeworkPick/commonAgtHkWindow/commonAgtHkWindow'
    import {
        delHomework, homeWorkInfo,
        homeworkTList, reassignHomeWork, recallHomeWork,
        teacherGradesH,
        teacherHOrderBy, teacherHStatus,
        teacherListsH,
        teacherSubjects,
        teacherTimeScope,
        teacherTypes, updateHomeWork
    } from "../../../config";
    import {EventBus} from "../../../assets/static/global/event-bus";
    import {message,messageBox} from 'element-ui'
    export default {
        name: "homeworkRecords",
        components:{
            commonAgtHkWindow
        },
        data(){
            return{
                //学科列表
                subjectList:[],
                //学科Id
                subjectId:null,
                //时间范围列表
                timeList:[],
                timeId:'',
                //年纪列表
                gradeList:[],
                //年纪Id
                gradeId:null,
                //作业类型列表
                homeTypeList:[],
                //类型id
                homeTypeId:null,
                //布置人下拉列表
                personDownList:[],
                personId:null,
                //作业列表上方排序方式
                homeOrder:[],
                orderById:'',
                //作业状态
                teacherStatusList:[],
                teacherStatusId:null,
                //分页
                currentPage:1,
                totalItem:0,
                //作业内容
                homeContentList:[],
                //条件加载
                conditionLoading:true,
                //作业内容加载
                contentLoading:true,
                //控制布置对象展开收起
                bzDxShow:false,
                //获取所修改的作业信息
                getHomeworkId:'',
                //获取查出当前作业的基本信息
                getSearchHomeworkInfo:''
            }
        },
        mounted(){
            this.subjectsPreview();
            this.searchTimeFwList();
            this.teacherGradesH();
            this.homeworkTypes();
            this.teacherListsH();
            this.teacherHOrderBy();
            this.homeStatus();
            //查出作业内容
            this.homeworkTList();
        },
        methods:{
            //查看详情
            lookDetail(title,id){
                this.$router.push({path:'/teacher/homework/homeworkDetailT',
                    query:{title:title,id:id}});
            },
            //再次布置
            async oneMoreTry(id){
                let result=await reassignHomeWork(id);
                if(result.status){
                    this.$router.push('/teacher/homeworkPick/commonAssignment');
                }
            },
            //页面切换
            async handleCurrentChange(){
                this.homeworkTList();
            },
            //修改信息
            async immediatelyArrange(val){
                let result=await updateHomeWork(this.getHomeworkId,
                    val.paperName,this.getSearchHomeworkInfo.isTiming,
                    this.getSearchHomeworkInfo.startAt,val.endTime,
                this.getSearchHomeworkInfo.gradeClasses);
                if(result.status){
                    this.$refs.commonAgHkWindow.closeDialog();
                    message({
                        message:'修改成功！',
                        type:'success',
                        duration:800,
                    })
                }
            },
            //撤回作业
            async recallHomework(id){
                this.homeContentList.forEach((val,index)=>{
                    if(val.id===id){
                        this.homeContentList[index].status=2;
                        this.homeContentList[index].canRecall=false;
                    }
                })
                let result=await recallHomeWork(id);
                if(result.status){
                    message({
                        message:'撤回成功！',
                        type:'success',
                        duration:800,

                    })
                }
            },
            //修改作业信息
            async updateHomework(id){
                this.getHomeworkId=id;
                let result=await homeWorkInfo(id);
                if(result.status){
                    this.getSearchHomeworkInfo=result.data;
                    this.$refs.commonAgHkWindow.arrangementHomework('修改作业信息',result.data);
                }
            },
            //删除作业
            async delHomework(id){
                messageBox.confirm('此操作将永久删除该作业, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.homeContentList.forEach((val,index)=>{
                        if(val.id===id){
                            this.homeContentList.splice(index,1);
                        }
                    })
                    let result=await delHomework(id);
                    if(result.status){
                        message({
                            message:'删除成功！',
                            type:'success',
                            duration:800
                        })
                    }
                }).catch(() => {

                });

            },
            //查出作业列表
            async homeworkTList(){
                this.contentLoading=true;
                // subjectId,typeId,graduateYear,teacherId,timeScope,status,pageIndex,pageSize
                let result=await homeworkTList(this.subjectId,this.homeTypeId,this.gradeId,this.personId,
                    this.timeId,this.teacherStatusId,this.currentPage,20);
                if(result.status){
                    this.contentLoading=false;
                    this.homeContentList=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }else{
                    this.contentLoading=false;
                }
            },
            //查出学科列表
            async subjectsPreview(){
                this.conditionLoading=true;
                let result=await teacherSubjects();
                if(result.status){
                    this.subjectList=result.data;
                    this.conditionLoading=false;
                }else{
                    this.conditionLoading=false;
                }
            },
            //查出时间范围列表
            async searchTimeFwList(){
                let result=await teacherTimeScope();
                if(result.status){
                    this.timeList=result.data;
                }
            },
            //查出年级列表
            async teacherGradesH(){
                let result=await teacherGradesH();
                if(result.status){
                    this.gradeList=result.data;
                }
            },
            //查出作业类型
            async homeworkTypes(){
                let result=await teacherTypes();
                if(result.status){
                    this.homeTypeList=result.data;
                }
            },
            //布置人下拉菜单
            async teacherListsH(){
                let result=await teacherListsH();
                if(result.status){
                    this.personDownList=result.data;
                }
            },
            //查出排序方式
            async teacherHOrderBy(){
                let result=await teacherHOrderBy();
                if(result.status){
                     this.homeOrder=result.data;
                }
            },
            //查出作业状态
            async homeStatus(){
                let result=await teacherHStatus();
                if(result.status){
                    this.teacherStatusList=result.data;
                }
            },
            //选择学科
            selectSubject(val){
                this.subjectId=val;
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择年级
            selectGrade(){
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择作业类型
            selectHomeworkType(){
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择布置人
            selectPerson(){
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择作业状态
            selectStatus(){
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择排序时间
            selectTime(){
                this.currentPage=1;
                this.homeworkTList();
            },
            //选择排序id
            selectOrderPaper(){
                this.currentPage=1;
                this.homeworkTList();

            },

        }
    }
</script>

<style lang="scss" scoped>
    .homeworkRecords{
        .secondLine{
            .active{
                color: #ffffff!important;
                padding: 5px 10px;
            }
        }
        .thirdLine{
            >div{
                margin-right:20px;
            }
        }
        .condition{
            min-height: 200px;
        }
        .sortPaper{
            background: #f5f8fb;
            border: 1px solid #e6eaf5;
            height: 34px;
            line-height: 34px;
            padding: 0 20px;
            margin-bottom: 20px;
        }
        .homeworkContentList{
            min-height: 300px;
            .text-small-secondary{
                span{
                    margin-right: 120px;
                }
            }
            .left{

                .dx.show{
                    height:auto!important;
                    overflow: visible!important;
                }
                .dx{
                    max-width: 1000px;
                    height:25px;
                    overflow: hidden;

                    .el-tag{
                        margin-bottom: 10px;
                    }
                    .right{
                        .el-button{
                            padding:0;
                        }
                        top:0;
                        right:0;
                    }
                }
            }
            .right{
                top:50px;
                right: 0;
                .status{
                    .green{
                        color:#00d486;
                    }
                    .gray{
                        color:gray;
                    }
                    .blue{
                        color:dodgerblue;
                    }
                    .danger{
                        color: orangered;
                    }
                }
                .settingRight{
                    .el-button{
                        color:dodgerblue;
                        border: 1px solid dodgerblue;
                    }
                }
            }
        }
    }
</style>
